import { SandboxPromptSchemaProps } from '@/schemas/sandboxPrompts/schema';

type GetSelectedProps<T> = {
	value: string;
	optionsArray: T;
};

export const getSelected = <T extends SandboxPromptSchemaProps[]>({
	value,
	optionsArray
}: GetSelectedProps<T>) => {
	return optionsArray.find(({ id, name }) => id === value || name === value);
};
